import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { toast } from "react-toastify";
import OTPInput from "react-otp-input";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    authenticationSeletor,
} from "../../store/slices/authenticationSlice";
import { forgotPassword, updatePassword } from "API/services/newServices";

const OtpBox = ({ show, setShow, user }) => {
    const [otp, setOtp] = useState("");
    const [otpError, setOtpError] = useState(false)
    const [counter, setCounter] = useState(30);
    const [password, setPassword] = useState("");
    const [passwordShow, setPasswordShow] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [confirmPasswordShow, setConfirmPasswordShow] = useState(false);
    const [passwordMismatch, setPasswordMismatch] = useState(false);
    const [resendOtp, setResendOtp] = useState(false);
    const { userDetail } = useSelector(authenticationSeletor);

    const verifyHandler = async (e) => {
        e.preventDefault();
        if (password !== confirmPassword) {
            setPasswordMismatch(true);
            return;
        }
        setPasswordMismatch(false);
        try {
            const param = {
                id: user.id,
                body: {
                    otp,
                    password,
                },
                admin: userDetail?.logintype == "rroomUser",
            };
            const res = await updatePassword(param);
            if (!res) {
                setOtpError(true)
                toast.error("Wrong OTP !");
                return;
            }
            if (res.status === true) {
                toast.success(res.message, {
                    autoClose: 1000,
                    pauseOnHover: true,
                    position: "top-right",
                });
                setShow(false)
                setPassword('')
            }
            // setShow(false);
            // toast.success("successfully changed Password!");
        }
        catch (err) {
            console.log(err)
        }
    };

    return (
        <div className={`otpModal ${show ? "active" : ""}`}>
            <div className="innerOtpModal">
                <section className="otpIfNoLogin verify-otp-booking position-relative">
                    <button
                        className="btn closeBtn text-black position-absolute top-0 end-0 m-0"
                        onClick={() => {
                            setShow(!show);
                            setPassword('')
                        }}
                    >
                        <FontAwesomeIcon icon="fa-solid fa-x" />
                    </button>
                    <div className="title">OTP</div>
                    <div className="title">Verification Code</div>
                    <p className="m-0 mb-2">
                        We have sent a verification code on your registered mobile numbers
                    </p>
                    <form id="inputs" onSubmit={verifyHandler}>
                        <OTPInput
                            value={otp}
                            onChange={setOtp}
                            numInputs={4}
                            renderInput={(props) => (
                                <input
                                    {...props}
                                    type="number"
                                    className="Otp-form-control"
                                />
                            )}
                        />
                        {otpError && <p className="text-error" style={{ fontSize: '12px', color: '#f00', margin: '5px 0px 0px' }}>Invalid OTP. Please try again.</p>}
                        <div className="left-and-right-inner-addon input-container mt-4 d-flex">
                            <i className="fa fa-lock left"></i>
                            <input
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                type={passwordShow ? "text" : "password"}
                                className="w-100 text-start fs-6 p-2"
                                placeholder="Enter Password"
                                autoComplete="new-password"
                                name="new-password"
                            />
                            {passwordShow ? (
                                <button
                                    type="button"
                                    className="right btn text-black p-1"
                                    onClick={() => setPasswordShow(!passwordShow)}
                                >
                                    <i className="fa fa-eye-slash"></i>
                                </button>
                            ) : (
                                <button
                                    type="button"
                                    className="right btn text-black p-1"
                                    onClick={() => setPasswordShow(!passwordShow)}
                                >
                                    <i className="fa fa-eye"></i>
                                </button>
                            )}
                        </div>

                        <div className="left-and-right-inner-addon input-container mt-3 d-flex">
                            <i className="fa fa-lock left"></i>
                            <input
                                value={confirmPassword}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                                type={confirmPasswordShow ? "text" : "password"}
                                className="w-100 text-start fs-6 p-2"
                                placeholder="Confirm Password"
                                autoComplete="new-password"
                                name="confirm-password"
                            />
                            <button
                                type="button"
                                className="right btn text-black p-1"
                                onClick={() => setConfirmPasswordShow(!confirmPasswordShow)}
                            >
                                <i className={`fa ${confirmPasswordShow ? "fa-eye-slash" : "fa-eye"}`}></i>
                            </button>
                        </div>
                        {passwordMismatch && (
                            <p className="text-error" style={{ fontSize: '12px', color: '#f00', margin: '5px 0px 0px' }}>
                                Password and Confirm Password do not match.
                            </p>
                        )}
                        <button
                            className="btn border border-primary text-primary submitBtn"
                            type="submit"
                            // disabled={otp && password ? false : true}
                            disabled={!otp || !password || !confirmPassword}
                        >
                            Submit
                        </button>
                    </form>
                </section>
            </div>
        </div>
    )
}

export default OtpBox